import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button, Popconfirm } from "antd";

/**
 * Renders a sign-out button
 */
export const SignOutButton = () => {
	const { instance } = useMsal();

	const handleLogout = (logoutType) => {
		if (logoutType === "popup") {
			instance.logoutPopup({
				postLogoutRedirectUri: "/",
				mainWindowRedirectUri: "/",
			});
		} else if (logoutType === "redirect") {
			instance.logoutRedirect({
				postLogoutRedirectUri: "/#/SignedOut",
			});
		}
	};
	return (
		<Popconfirm
			placement="bottomRight" 
			title="Are you sure you want to log out? Any unsaved data will be lost." 
			onConfirm={() => handleLogout("redirect")} okText="Logout" cancelText="Cancel"
			okButtonProps={{ danger : true}}>
			<Button type="link" danger size="small">
				Sign out
			</Button>
		</Popconfirm>
	);
};
